import get from './methodGet';
import patch from './methodPatch';
import post from './methodPost';
// import del from './methodDelete';

export default { ...get, ...patch, ...post };
